import React,{ useState } from 'react';
import styled from 'styled-components';
import { useQuery } from '@apollo/client';
import {  useHistory } from 'react-router-dom';
import { If, Then } from 'react-if';

// Components
import Loading from '../components/Loading';
import FormErrors, { trowError } from '../components/FormErrors';
import ItemPost from '../components/ItemPost';
import ModalWindow from '../components/ModalWindow';


import AcreditacionProfile from '../models/AcreditacionProfile';
import { LIST_NOTIFICATIONS } from '../models/Notify';


const moment = require('moment-timezone').tz.setDefault('America/Mexico_City')
moment.locale('es');

const StyledPage = styled.main`
  display: flex;
  align-items:center;
  justify-content:center;
  flex-wrap:wrap;
  height: 100%;
  max-width:800px;
  width:100%;
  margin:0 auto;


  .listPost{
    display: flex;
    flex-direction: column;    
    list-style: none;
    padding: 0px;

    li{
        border-bottom: 1px solid var(--color-gray-light);
        padding: 20px 0px;
    }

  }
  
  .modalContent{
    padding: 10px;
    h2{
        font-size: 35px;
        padding-bottom: 20px;
        text-align: center;
    }
  }

`;

const SubTitulo=styled.div`
    width:100%;
    margin-bottom:50px;
    h2{
        color:var(--color-azul);
    }
`;





export default  () => {
    let history = useHistory();
    let UserInfo=AcreditacionProfile.getProfile();
    const [contentModal, setContentModal] = useState<object|null>(null);
    

  
    const { loading, error, data } = useQuery(LIST_NOTIFICATIONS,{
        variables:{
            first:10,
            tipo:["ABONADOS"]
        },
        context:{
            clientName:'SITE'
        }        
    });

    if(loading)
        return <Loading />


    console.log({data});

    return (
        <StyledPage>
            <SubTitulo>
                <h2>Notificaciones</h2>
            </SubTitulo>
            <ol className='listPost'>
                {data?.allPushNotifys?.data?.map( item => (<li><ItemPost  {...item} onClick={ () => setContentModal(item) } /></li>))}    
            </ol>
          

            <If condition={contentModal}>
                <Then>
                    <ModalWindow onClickClose={() => setContentModal(null)}>
                        <div className='modalContent'>
                            <h2>{contentModal?.mensaje}</h2>
                            <div dangerouslySetInnerHTML={{ __html: contentModal?.contenido }} />
                        </div>
                    </ModalWindow>
                </Then>
            </If>              
        </StyledPage>
    )
}